import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { AuthService } from '../../../Auth/AuthService';
import Message from '../Common/Message';

const messageContent = 'Authentification callback processing...';

const Callback = () => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const [redirectRoute, setRedirectRoute] = useState<string | null>('');

  useEffect(() => {
    window.document.title = messageContent;
    AuthService.signinRedirectCallback().then(
      user => {
        setRedirectRoute(user.state);
        setLoaded(true);
      },
      error => {
        console.error(error);
        setFailed(true);
      }
    );
  }, []);

  if (failed) {
    return <Redirect to='/identity-error' />;
  }

  if (loaded) {
    if (redirectRoute) {
      return <Redirect to={redirectRoute} />;
    } else {
      return <Redirect to='/stitching-tool' />;
    }
  }

  return <Message content={messageContent} />;
};

export default Callback;
